export enum BazaNcBankAccountExport {
    NC = 'nc',
    Dwolla = 'dwolla',
}
